<template>
  <section :class="{ container: true, 'container-mobile': isMobile }">
    <header class="header">
      <div class="logo">
        <div class="left">
          <img
            :width="isMobile ? '340px' : '500px'"
            src="../../static/icon/banner12.png"
          />
          <!-- <span>{{$t('message.Home_Title')}}</span> -->
        </div>
        <!-- <div class="right">
          <span @click="changeLang">{{$t('message.Home_Lang')}}</span>
          <img src="../../static/icon/icon_jianti.svg" v-if="this.$i18n.locale === 'zhCHT'"/>
          <img src="../../static/icon/icon_fanti.svg" v-if="this.$i18n.locale === 'zhCHS'"/>
        </div> -->
      </div>
    </header>

    <div :class="{ content: true, 'content-mobile': isMobile }">
      <yd-slider autoplay="5000" speed="400" :height="isMobile ? '200' : '540'">
        <!--
        <yd-slider-item @click="toNewsCom">
          <img
            @click="toNewsCom"
            height="540px"
            src="../../static/news/20260714/banne1.jpg"
            class="banner-img"
          />
        </yd-slider-item>
        -->
        <yd-slider-item :height="isMobile ? '200px' : '540px'">
          <img
            :height="isMobile ? '200px' : '540px'"
            src="../../static/icon/banner110.jpg"
          />
        </yd-slider-item>
        <yd-slider-item :height="isMobile ? '200px' : '540px'">
          <img
            :height="isMobile ? '200px' : '540px'"
            src="../../static/icon/banner111.jpg"
          />
        </yd-slider-item>
      </yd-slider>
      <!-- <el-carousel indicator-position="outside">
        <el-carousel-item>
          <img
            @click="toNewsCom"
            height="540px"
            src="../../static/news/20260714/banne1.jpg"
            class="banner-img"
          />
        </el-carousel-item>
        <el-carousel-item>
          <img height="540px" src="../../static/icon/banner110.jpg" />
        </el-carousel-item>
        <el-carousel-item>
          <img height="540px" src="../../static/icon/banner111.jpg" />
        </el-carousel-item>
      </el-carousel> -->
      <!-- <div class="title">{{ $t('message.Home_Tc') }}</div> -->
      <!-- <div class="title-tc">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide"><img src="../../static/icon/pic_2.png" /></div>
            <div class="swiper-slide"><img src="../../static/icon/pic_3.png" /></div>
            <div class="swiper-slide"><img src="../../static/icon/pic_4.png" /></div>
            <div class="swiper-slide"><img src="../../static/icon/pic_5.png" /></div>
            <div class="swiper-slide"><img src="../../static/icon/pic_6.png" /></div>
            <div class="swiper-slide"><img src="../../static/icon/pic_7.png" /></div>
            <div class="swiper-slide"><img src="../../static/icon/pic_1.png" /></div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div> -->

      <div class="title">{{ $t("message.Home_objective") }}</div>
      <div>
        <div class="item-content" v-for="(item, index) in ContentList">
          <img class="image-left" :src="item.src" />
          <span class="info">{{ item.title }}</span>
        </div>
      </div>

      <!-- <div class="title">{{ $t('') }}</div>
      <div>
        <div class="item-content" v-for="(item, index) in ContentList">
          <img class="image-left" :src="item.src" />
          <span class="info">{{ item.title }}</span>
        </div>
      </div> -->

      <div class="title">我們的職能</div>
      <div class="flex-content">
        <div class="flex-content-child" v-for="(item, index) in ProjectList">
          <img :src="item.src" />
          <p>{{ item.title }}</p>
        </div>
      </div>
      <div class="news-v">
        <ul>
          <li
            class="easeBottom li-item md:flex mb-8 md:mb-16 rounded-lg"
            :id="`news-${newsItem.id}`"
          >
            <div class=" left-v mb-3 md:mb-0 md:w-1/2 lg:w-3/6 ">
              <h3
                class=" top-title mx-2 py-1 pt-4 block md:hidden text-[#DC192B] mi:text-xl mi:leading-6 md:leading-6 md:text-lg hover:text-[#DC192B]"
              >
                <router-link :to="`${routeStr}?id=${newsItem.id}`">{{
                  newsItem.title
                }}</router-link>
              </h3>
              <p class="top-title text-slate-500 mx-4 mb-2 md:hidden ">
                {{ newsItem.date }}
              </p>
              <router-link :to="`${routeStr}?id=${newsItem.id}`">
                <div class="img-box">
                  <img
                    class="rounded-lg w-full h-48  lg:h-80 "
                    :title="newsItem.title"
                    :src="
                      newsItem.navImg ||
                        (newsItem.imgageList &&
                          newsItem.imgageList[0] &&
                          newsItem.imgageList[0].img)
                    "
                  />
                </div>
              </router-link>
            </div>
            <div
              class=" right-v px-2 pb-2 md:w-3/4  md:px-10 max-h-48  lg:max-h-80"
            >
              <h3
                class="right-v-title py-2 pt-5 hidden md:block text-[#DC192B]  mi:leading-10 md:leading-6 text-xl lg:text-2xl hover:text-[#DC192B] "
              >
                <router-link :to="`${routeStr}?id=${newsItem.id}`">{{
                  newsItem.title
                }}</router-link>
              </h3>
              <p class=" right-v-date text-slate-500  mb-2 hidden md:block">
                {{ newsItem.date }}
              </p>
              <div
                class="right-v-c  ellipsis-news"
                v-html="
                  newsItem.desc.join('<br/>') ||
                    (newsItem.imgageListTwo &&
                      newsItem.imgageListTwo[0] &&
                      newsItem.imgageListTwo[0].content) ||
                    ''
                "
              ></div>
              <div class="h-3 md:hidden "></div>
            </div>
          </li>
        </ul>
      </div>

      <div class="ft">
        <!-- ———————————— 更多內容即將更新，敬請期待 ———————————— -->
      </div>
    </div>

    <footer class="footer">
      <div class="mess">
        <div class="foo-left">
          <div class="zx">
            <!-- <span>{{ $t('message.Home_Download') }}</span> -->
            <div class="more-download">
              <div>
                <!-- <img class="qr-code" src="../../static/icon/Android_ios.png" /> -->
                <!--<p><img class="plateform" src="../../static/icon/Android_ios.png"/> <span class="text-info">for iPhone</span> </p>-->
              </div>
              <!--<div>-->
              <!--<img class="qr-code" src="../../static/1555327408.png"/>-->
              <!--<p><img class="plateform" src="../../static/icon/icon_android.png"/> <span class="text-info">for Android</span></p>-->
              <!--</div>-->
            </div>
          </div>
          <div class="more">
            <!-- <div class="more-gz">{{ $t('message.Home_Focus') }}</div> -->
            <!-- <div>
              <el-popover placement="bottom" width="150" trigger="hover">
                <div align="center"><img width="125px" src="../../static/qrcode/wxgzh.jpg" /></div>
                <img slot="reference" src="../../static/icon/icon_weixin.png" />
              </el-popover>

              <el-popover placement="bottom" width="150" trigger="hover">
                <div align="center"><img width="125px" src="../../static/qrcode/weibo.png" /></div>
                <img slot="reference" src="../../static/icon/icon_weibo.png" />
              </el-popover>

              <el-popover placement="bottom" width="300px" height="300px" trigger="hover">
                <div align="center"><img width="300px" src="../../static/qrcode/douyin.png" /></div>
                <img slot="reference" src="../../static/icon/icon_douyin.png" />
              </el-popover>

              <el-popover placement="bottom" width="150" trigger="hover">
                <div align="center"><img width="125px" src="../../static/qrcode/ins.png" /></div>
                <img slot="reference" src="../../static/icon/icon_instagram.png" />
              </el-popover>

              <el-popover placement="bottom" width="150" trigger="hover">
                <div align="center"><img width="125px" src="../../static/qrcode/facebook.png" /></div>
                <img slot="reference" src="../../static/icon/icon_facebook.png" />
              </el-popover>

              <el-popover placement="bottom" width="150" trigger="hover">
                <div align="center"><img width="125px" src="../../static/qrcode/tuite.png" /></div>
                <img slot="reference" src="../../static/icon/icon_twitter.png" />
              </el-popover>
            </div> -->

            <!--<el-popover placement="bottom" width="150" trigger="hover">-->
            <!--<div align="center">-->
            <!--<img width="125px" src="../../static/1555327408.png"/>-->
            <!--</div>-->
            <!--<img slot="reference" src="../../static/icon/qrcode/大灣區推特.png"/>-->
            <!--</el-popover>-->
          </div>
          <div class="thr">
            <!-- <p>{{ $t('message.Home_Address') }}</p> -->
            <p class="foot-p">
              地址：香港北角英皇道351-353號銀輝中心5/F，C&D室
            </p>
            <p class="foot-p">
              {{ $t("message.Home_PhoneNumber") }}：852-2887 2678
            </p>
            <p class="foot-p">{{ $t("message.Home_Fax") }}：852-2887 2618</p>
            <p class="foot-p">
              {{ $t("message.Home_Email") }}：bili2678@gmail.com
            </p>
            <!-- <p>{{ $t('message.Home_Url') }}：http://www.gbafa.org</p> -->
          </div>
        </div>
      </div>

      <div class="bottom-info">
        <!-- <span>{{ $t('message.Home_Copyright') }} COPYRIGHT©GREATER BAR AREA FINTECH ASSOCIATION LIMITED.All RIGHTS RESERVED</span> -->
        <span
          >香港莊氏璧立宗親會 版權所有 HONGKONG CHUANGS BILI CLANSMEN
          ASSOCIATION</span
        >
      </div>
    </footer>
  </section>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "index",
  data() {
    return {
      langImageChs: "../../static/icon/icon_jianti.svg",
      langImageCht: "../../static/icon/icon_fanti.svg",
      banner1: require("../../static/news/20260714/banne1.jpg"),

      ContentList: [
        {
          src: "../static/icon/icon_red.png",
          title:
            "凡屬於璧立裔孫居住香港的本會會員，須如同手足互助互濟，共解危困。本會將對此義不容辭地給予義務支持及協助，此為本會的主要宗旨。"
        },
        {
          src: "../static/icon/icon_blue.png",
          title:
            "聯絡居住在香港、澳門、臺灣和海內外之璧立裔孫，加強聯絡，促進聯誼，從而進行經濟、文化、技術交流和合作，促進發展，共謀福祉。"
        },
        {
          src: "../static/icon/icon_yellow.png",
          title:
            "愛國、愛港、愛鄉，鼓勵會員和鄉親朋友積極參與社會公益事務和造福家鄉。"
        },
        {
          src: "../static/icon/icon_deepgreen.png",
          title:
            "本會為非牟利機構，為發展會務與實踐本會宗旨，可向會員及社會人士以及商號等籌募經費並接受捐款捐物。"
        }
      ],

      ProjectList: [
        { src: "../static/icon/pic_pingtai.png", title: "敦親睦族" },
        { src: "../static/icon/pic_qiaoliang.png", title: "造福家鄉" },
        { src: "../static/icon/pic_xiangmu.png", title: " 促進發展" },
        { src: "../static/icon/pic_qingnian.png", title: "敬老助學" },
        { src: "../static/icon/pic_peixun.png", title: "社會公益" }
      ],
      // ContentList: [
      //   { src: '../static/icon/icon_red.png', title: this.$t('message.Home_objective_1') },
      //   { src: '../static/icon/icon_blue.png', title: this.$t('message.Home_objective_2') },
      //   { src: '../static/icon/icon_yellow.png', title: this.$t('message.Home_objective_3') },
      //   { src: '../static/icon/icon_deepgreen.png', title: this.$t('message.Home_objective_4') },
      //   { src: '../static/icon/icon_purple.png', title: this.$t('message.Home_objective_5') },
      //   { src: '../static/icon/icon_green.png', title: this.$t('message.Home_objective_6') },
      //   { src: '../static/icon/icon_orange.png', title: this.$t('message.Home_objective_7') }
      // ],

      // ProjectList: [
      //   { src: '../static/icon/pic_pingtai.png', title: this.$t('message.Home_work_1') },
      //   { src: '../static/icon/pic_qiaoliang.png', title: this.$t('message.Home_work_2') },
      //   { src: '../static/icon/pic_xiangmu.png', title: this.$t('message.Home_work_3') },
      //   { src: '../static/icon/pic_qingnian.png', title: this.$t('message.Home_work_4') },
      //   { src: '../static/icon/pic_peixun.png', title: this.$t('message.Home_work_5') },
      //   { src: '../static/icon/pic_zixun.png', title: this.$t('message.Home_work_6') },
      //   { src: '../static/icon/pic_tixi.png', title: this.$t('message.Home_work_7') }
      // ],

      // CommentList: [
      //   { src: '../static/icon/icon_red.png', title: this.$t('message.Home_wish_1') },
      //   { src: '../static/icon/icon_blue.png', title: this.$t('message.Home_wish_2') },
      //   { src: '../static/icon/icon_yellow.png', title: this.$t('message.Home_wish_3') },
      //   { src: '../static/icon/icon_deepgreen.png', title: this.$t('message.Home_wish_4') }
      // ]
      routeStr: "news",
      newsItem: {
        id: 1,
        title:
          "「東江綠韻．南沙同行」生態研學之旅圓滿舉行 助港澳青年探索大灣區綠色發展",
        nav: "",
        date: "2026-04-29",
        imgageList: [
          {
            img: require("../../static/news/20260714/wxtp_20260714114124_85_157.jpg"),
            alt: ""
          }
        ],
        tagList: ["Technology", "Education", "Internet", "Media"],
        desc: [
          "2026年4月3日至4日，由香港莊氏璧立慈善基金有限公司主辦，並獲民政及青年事務局、青年發展委員會及政府資助計劃慷慨贊助的「東江綠韻．南沙同行」生態研學之旅於廣州南沙圓滿結束。本次活動專為12至35歲的香港青年而設，旨在透過實地考察與交流，讓青年深入了解大灣區的生......"
        ]
      },
      isMobile: false
    };
  },
  mounted() {
    let mySwiper = new Swiper(".swiper-container", {
      direction: "horizontal",
      loop: true,
      autoplay: true,
      // speed: 5000,
      observer: true,
      slidePerView: "auto",
      centeredSlides: true,
      spaceBetween: 91,
      loopAdditionalSlides: 100,
      pagination: {
        el: ".swiper-pagination"
      }
    });
    let curiWidth = document.body.clientWidth;
    console.log("curiWidth", curiWidth);
    if (curiWidth < 768) {
      this.isMobile = true;
    }
  },
  methods: {
    changeLang() {
      let type = sessionStorage.getItem("lang-key") || this.$i18n.locale;
      if (type === "zhCHT") {
        sessionStorage.setItem("lang-key", "zhCHS");
      } else {
        sessionStorage.setItem("lang-key", "zhCHT");
      }
      location.reload();
    },
    toNewsCom() {
      console.log("toNewsCom");
    }
  }
};
</script>
<style scoped>
.header {
  height: 118px;
  position: absolute;
  width: 100%;
  background: #fff;
  left: 0;
  top: 0;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
.logo {
  width: 1104px;
  margin: 0 auto;
  height: 118px;
  line-height: 118px;
  position: relative;
  display: flex;
  justify-content: space-between;
}
.left {
  width: 50%;
}
.left span {
  margin-left: 94px;
  font-size: 24px;
  color: #333333;
}
.right {
}
.right span {
  font-size: 18px;
  color: #333333;
  margin-right: 35px;
  cursor: pointer;
}
.left img {
  display: inline-block;
  position: absolute;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
}
.right img {
  display: inline-block;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  margin-top: auto;
  margin-bottom: auto;
}
.content {
  width: 1104px;
  background: #fff;
  margin: 120px auto 100px auto;
}
.content.content-mobile .yd-slider-item img {
  height: 200px !important;
}

.footer {
  background: #f0f0f0;
  /* height: 636px; */
}
.mess {
  width: 1104px;
  height: 200px;
  margin: 0 auto;
}

.title {
  font-size: 34px;
  color: #333333;
  line-height: 34px;
  padding: 48px 0;
}
.title-tc {
  position: relative;
  /* overflow: hidden; */
  overflow: -webkit-paged-y;
}
.item-content {
  line-height: 60px;
  padding: 0 0 0 60px;
  position: relative;
}
.image-left {
  /* display: inline-block;
  position: relative;
  top: 10px; */
  display: inline-block;
  position: absolute;
  top: 4px;
}
.info {
  font-size: 22px;
  color: #333333;
  line-height: 24px;
  /* margin-left: 24px; */
  display: inline-block;
  line-height: 45px;
  margin-left: 50px;
}
.flex-content {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.flex-content-child {
  width: 25%;
  text-align: center;
}
.flex-content-child img {
  width: 100px;
}
.flex-content-child p {
  font-size: 22px;
  color: #333333;
  padding: 30px 0;
}

.image-hope {
  width: 50%;
  position: relative;
  height: 60px;
  line-height: 60px;
  padding: 0 60px;
}
.image-hope img {
  display: inline-block;
  position: relative;
  top: 10px;
}
.image-hope span {
  font-size: 22px;
  color: #333333;
  line-height: 24px;
  margin-left: 24px;
}
.zx {
  top: 66px;
  position: relative;
}
.zx span {
  opacity: 0.8;
  font-size: 22px;
  color: #333333;
  text-align: left;
  display: inline-block;
  padding: 30px 0;
}
.more-download {
  display: flex;
  text-align: center;
}
.more-download div {
  margin: 10px 0 10px 30px;
}
.qr-code {
  width: 120px;
  height: 120px;
}
.plateform {
  width: 23px;
}
.text-info {
  font-size: 24px;
  color: #333333;
}

.more {
  position: relative;
  left: 431px;
  width: 674px;
  top: -168px;
}
.more-gz {
  margin-left: 36px;
  opacity: 0.8;
  font-size: 24px;
  color: #333333;
  padding: 30px 0;
}
.more img {
  width: 32px;
  margin-left: 32px;
}
.thr {
  position: relative;
}
.thr p {
  margin: 0 0 24px 0;
  font-size: 18px;
  color: #333333;
}
.thr p:nth-child(2) {
  display: inline-block;
  width: 42%;
}
.thr p:nth-child(3) {
  display: inline-block;
  width: 48%;
}
.thr p:nth-child(4) {
  display: inline-block;
  width: 42%;
}
.thr p:nth-child(5) {
  display: inline-block;
  width: 48%;
}

.container-mobile .footer .thr {
  display: block;
  padding: 0 10px;
}
.container-mobile .more {
  display: none;
}
.container-mobile .mess {
  width: 100vw;
  height: 240px;
}
.container-mobile .footer .thr .foot-p {
  width: 100%;
  display: block !important;
}
.container-mobile .bottom-info {
  height: auto;
}
.container-mobile .bottom-info span {
  text-wrap: wrap;
  white-space: wrap;
}
.container-mobile .content.content-mobile .title {
  font-size: 26px;
  padding-left: 10px;
}
.container-mobile .content.content-mobile .item-content {
  padding-left: 10px;
}
.container-mobile .content.content-mobile .item-content .info {
  font-size: 18px;
}
.container-mobile .content.content-mobile .flex-content .flex-content-child {
  width: 33%;
}

.bottom-info {
  background: #212121;
  height: 40px;
  line-height: 40px;
  color: white;
  text-align: center;
  font-size: 14px;
}

/*swiper*/
.swiper-container {
  /*margin-top: 0.2rem;*/
  width: 251px;
  height: 351px;
  overflow: visible !important;
  position: relative;
}
.swiper-container .swiper-wrapper .swiper-slide {
  width: 250px;
  border-radius: 0.12rem;
}
.swiper-container .swiper-wrapper .swiper-slide img {
  width: 100%;
  height: 351px;
  border-radius: 0.12rem;
}
.swiper-container .swiper-wrapper .swiper-slide-prev {
  /*margin-top: 0.18rem;*/
  height: 351px !important;
}
.swiper-container .swiper-wrapper .swiper-slide-prev img {
  height: 351px !important;
}
.swiper-container .swiper-wrapper .swiper-slide-next {
  /*margin-top: 0.18rem;*/
  height: 351px !important;
}
.swiper-container .swiper-wrapper .swiper-slide-next img {
  height: 351px !important;
}
.swiper-container .swiper-wrapper .swiper-slide-active {
  width: 250px;
}
.swiper-pagination {
  bottom: 0.1rem !important;
}

.ft {
  width: 100%;
  text-align: center;
  font-size: 26px;
  margin-top: 30px;
}
.news-v {
  margin-top: 20px;
}
.news-v li {
  display: flex;
}
.news-v li .left-v {
  width: 40%;
  height: 320px;
}
.news-v li .left-v .img-box img {
  height: 320px;
}
.news-v li .right-v {
  width: 60%;
  height: 320px;
  padding-top: 12px;
  padding-left: 12px;
  padding-right: 20px;
}
.news-v li .right-v-title {
  font-size: 26px;
}
.news-v li .right-v-date {
  font-size: 16px;
  color: #5c5b5b;
  margin: 10px 0;
}
.news-v li .right-v-c {
  font-size: 16px;
  line-height: 1.6;
  height: 180px;
}
.content.content-mobile .news-v li {
  display: block;
}
.content.content-mobile .news-v li .right-v {
  width: 100%;
  height: auto;
}
.content.content-mobile .news-v li .left-v {
  width: 100%;
  height: auto;
}
.content.content-mobile .news-v li .right-v-title {
  display: none;
}
.content.content-mobile .news-v li .right-v-date {
  display: none;
}
.content.content-mobile .news-v li .top-title {
  font-size: 20px;
  margin: 6px;
}
@media (min-width: 100px) and (max-width: 768px) {
  .content {
    max-width: 668px;
    width: 100vw;
    background: #fff;
    margin: 120px auto 100px auto;
  }
}
@media (min-width: 768px) {
  .top-title {
    display: none;
  }
}
@media (max-width: 768px) {
  .ellipsis-news {
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 6;
    word-wrap: break-word; /* 強制英文數字在邊界處換行 */
    overflow-wrap: break-word; /* 對於兼容性更好的情況 */
    white-space: pre-wrap;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .ellipsis-news {
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    word-wrap: break-word; /* 強制英文數字在邊界處換行 */
    overflow-wrap: break-word; /* 對於兼容性更好的情況 */
    white-space: pre-wrap;
  }
}
@media (min-width: 1024px) {
  .ellipsis-news {
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 7;
    word-wrap: break-word; /* 強制英文數字在邊界處換行 */
    overflow-wrap: break-word; /* 對於兼容性更好的情況 */
    white-space: pre-wrap;
  }
}
.w49 {
  width: 49.8%;
}
.li-item {
  transition: all 0.6s;
  box-shadow: 0 1px 20px -6px rgba(36, 21, 21, 0.5);
}
.li-item .img-box {
  overflow: hidden;
}
.li-item .img-box img {
  transition: all 0.6s;
  /* // cover 保持原有尺寸比例。但部分內容可能被剪切。
      // scale-down、contain、none、scale-down、fill
      // cover 保持原有尺寸比例。但部分內容可能被剪切。 */
  object-fit: cover;
}
.li-item:hover {
  box-shadow: 0 1px 40px -8px rgba(36, 21, 21, 0.5);
}
.li-item:hover .img-box {
  transition: all 0.6s ease;
}
.li-item:hover .img-box img {
  transform: scale(1.1);
  /* // height: 400px; */
  overflow: hidden;
}

.banner-img {
  /* cursor: pointer; */
}
.container-mobile .logo {
  width: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue